import { PropsWithChildren, useState } from "react";
import { useAsync } from "@Hooks/abstract/useAsync";
import {
  FeatureFlagOrganization,
  getFeatureFlags,
  GetFeatureFlagsOrganization,
  IFeatureFlag,
} from "@Api/featureFlagApi";
import { FeatureFlagContext, FlagRecord } from "../contexts/FeatureFlagContext";

export const FeatureFlagProvider = (props: PropsWithChildren) => {
  const [flags, setFlags] = useState<FlagRecord>();
  const { data: featureFlagOrganization } = useAsync(() => GetFeatureFlagsOrganization());
  const { data: featureFlags } = useAsync(() => getFeatureFlags());

  const mergeFlags = (
    featureFlags: IFeatureFlag[] | null,
    featureFlagsOrganization: FeatureFlagOrganization[]
  ): FlagRecord => {
    if (!featureFlags || !featureFlagOrganization) return {};

    const flags: FlagRecord = {};
    for (const flag of featureFlags) {
      flags[flag.identifier] = flag.defaultValue;
    }
    for (const flag of featureFlagsOrganization) {
      flags[flag.flag.identifier] = flag.value;
    }
    return flags;
  };

  const mergedFlags = mergeFlags(featureFlags, featureFlagOrganization || []);

  return (
    <FeatureFlagContext.Provider value={{ flags: mergedFlags, setFlags }}>
      {props.children}
    </FeatureFlagContext.Provider>
  );
};
